import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { SessionService } from '@core';

import { FeasibilityResult } from '../../models/feasibility-result.model';
import { TaskFeasibility } from '../../models/task-feasibility.model';
import { TaskFeasibilityInfo } from '../../models/task-feasibility-info.model';

@Injectable({
    providedIn: 'root'
})
export class FeasibilityService {
    private readonly httpClient = inject(HttpClient);
    private readonly sessionService = inject(SessionService);


    public getFeasibility(taskIds: string[]): Observable<FeasibilityResult> {
        const url = `${this.sessionService.getApiUrl()}/feasibility/${this.sessionService.requestId}`;
        const body = { taskIds };
        return this.httpClient.put<FeasibilityResult>(url, body);
    }

    public getTaskFeasibilityInfo(
        taskId: string,
        taskFeasibility: TaskFeasibility,
        excludeWarnings?: boolean
    ): TaskFeasibilityInfo {
        taskFeasibility = JSON.parse(JSON.stringify(taskFeasibility));
        const taskFeasibilityInfo = <TaskFeasibilityInfo>{ feasibilityCount: 0 };

        Object.keys(taskFeasibility.errors).forEach(key => {
            const feasibilityError = taskFeasibility.errors[key].find((item: any) => item.taskId === taskId);
            if (feasibilityError && taskFeasibilityInfo.feasibilityCount <= 2) {
                if (feasibilityError.numberOfNonAllocatedTasks) {
                    if (feasibilityError.numberOfNonAllocatedTasks === 0) {
                        return;
                    }
                    feasibilityError.numberOfNonAllocatedTasks--;
                }
                taskFeasibilityInfo[key.slice(0, -1)] = true;
                taskFeasibilityInfo.feasibilityCount++;
            }
        });

        if (!excludeWarnings) {
            Object.entries(taskFeasibility.warnings).forEach(([key, items]) => {
                const feasibilityWarning = items.find(item => item.taskId === taskId);
                if (feasibilityWarning && taskFeasibilityInfo.feasibilityCount <= 2) {
                    taskFeasibilityInfo[key.slice(0, -1)] = true;
                    taskFeasibilityInfo.feasibilityCount++;
                }
            });
        }

        return taskFeasibilityInfo;
    }
}
